import React from 'react';
import ReactDOM from 'react-dom';
import { injectGlobal } from 'styled-components';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

// language=CSS
injectGlobal`
* { box-sizing: border-box; }

body {
  margin: 0;
  font-family: sans-serif;
}
`;

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js